import { NeedsResourceDetailsDto } from '@act/shared/data-transfer-objects';
import { userAppSelectors } from 'redux/slices/usersSlice';
import {
  StyledHistoryEntry,
  StyledHistoryEntrySubheader,
  getHistoryEntryDateLine,
} from './history-display';

interface ResourceDetailsHistoryProps {
  resourceDetails: NeedsResourceDetailsDto;
}

const ResourceDetailsHistoryEntry = ({
  resourceDetails,
}: ResourceDetailsHistoryProps) => {
  const creatorName = userAppSelectors.useSelectUserById(
    resourceDetails?.creatorId
  )?.name;

  return (
    <StyledHistoryEntry
      header={`Resource referred: ${resourceDetails?.resourceName}`}
      content={
        <StyledHistoryEntrySubheader>
          {getHistoryEntryDateLine(resourceDetails?.createdAt, creatorName)}
        </StyledHistoryEntrySubheader>
      }
    />
  );
};

export default ResourceDetailsHistoryEntry;
